import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { SeparatorFactory } from "../../factories/SeparatorFactory"
import { EditorComponentContract } from '../EditorComponentContract'

export class Separator extends EditorComponentContract {
  constructor() {
    super(Variations);
    this.htmlBuilder = HtmlBuilder
    this.factory = new SeparatorFactory
  }

  info() {
    return {
      name: 'Separator',
      icon: 'fa-grip-lines',
      variations: this.variationsInfo()
    }
  }

  elementIds() {
    return ['id', 'iconId', 'iconContainerId']
  }

  elementClasses() {
    return [
      'classes', 'containerClasses', 'contentClasses',
      'iconContainerClasses', 'iconClasses',
      'textClasses'
    ]
  }

  elementContents() {
    return ['hasIcon', 'hasText', 'text', 'icon', 'class']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
      {id: 'iconId', element: 'id', styles: 'iconStyles', selector: '#', variation: null},
      {id: 'textId', element: 'id', styles: 'textStyles', selector: '#', variation: null},
      {id: 'iconContainerId', element: 'id', styles: 'iconContainerStyles', selector: '#', variation: null}
    ]
  }
}
